import React from 'react';
import { connect } from 'react-redux';

// Types
import { ReduxState } from '../../redux/modules/types';

// Utils
import { userHasPermissionEnabled } from '../../utils/permissions';
import User from '@/types/user';

type StateProps = {
  user?: User | null;
};

type Props = StateProps & {
  permissions?: string[];
  forcedFalse?: boolean;
  children: (user: User) => React.ReactNode;
};

export const PrivateComponent = (props: Props) => {
  const { children, permissions, user, forcedFalse } = props;

  if (user != null && (permissions == null || userHasPermissionEnabled(user, ...permissions)) && !forcedFalse) {
    return <>{children(user)}</>;
  }

  return null;
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(PrivateComponent);
